<template>
  <div class="wrap">
    <el-button type="primary" @click="onExport">
      <slot>导出</slot>
    </el-button>
    <el-dialog title="导出" :visible="isShow" width="500px" :destroy-on-close="true" :close-on-click-modal='false'
      @close="onClose">
      <div class="content">
        <p>正在生成导出文件，请前往<span>【我的导出】</span>中查看和下载文件。</p>
        <div class="btn mt20">
          <el-button type="primary" @click="$router.push('/patrol/patrolExport')">立即前往</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShow: false
    }
  },

  methods: {
    getExportUrl () {
      const exportMap = new Map()
      exportMap.set('0', this.$apis.patrol.exportIssue) // 导出巡查问题清单
      exportMap.set('1', this.$apis.patrol.planexporttoexcel) // 导出巡查管理表单
      exportMap.set('2', this.$apis.patrol.taskexporttoexcel) // 导出巡查管理-执行记录-任务记录表单
      exportMap.set('3', this.$apis.patrol.facilityExcel) // 资产导出
      return exportMap.get(this.type)
    },

    onExport () {
      // console.log('下载查询条件', this.params)
      this.$axios.get(this.getExportUrl(), this.params).then(res => {
        if (res === 0) {
          this.$message.error('导出失败:当前条件下没有数据!')
        } else {
          this.isShow = true
        }
      })
    },

    onClose () {
      this.isShow = false
    }
  }
}
</script>
<style scoped lang='scss'>
.wrap {
  display: inline-flex;
  margin-left: 10px;
}

.content {
  p {
    text-align: center;

    span {
      color: #1eb6ae;
    }
  }

  .btn {
    display: flex;
    justify-content: center;
  }
}
</style>
